<template>
  <!-- 질문 입력창 — 입력 중인 글자를 이 컴포넌트 안에만 둔다.
       부모(AiAgentSideBar)의 data 에 두면 글자마다 부모 전체가 다시 렌더링되고,
       그때마다 대화 속 모든 차트가 updateOptions 를 부른다 (대화가 길수록 입력이 느려진 까닭). -->
  <b-input-group>
    <b-form-input
      v-model="text"
      class="user-q-input"
      placeholder="질문을 입력하세요..."
      type="text"
      autocomplete="off"
      :disabled="disabled"
      @keydown.enter="send"
    />
    <b-input-group-append v-if="text">
      <button class="ml-1 q-btn" :disabled="disabled" @click="send">
        <i class="ti ti-send" style="font-size:15px" aria-hidden="true"></i>
      </button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { BFormInput, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'

export default {
  name: 'AgentQuestionInput',
  components: { BFormInput, BInputGroup, BInputGroupAppend },
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { text: '' }
  },
  methods: {
    send(event) {
      // 한글 조합 중의 Enter 는 조합을 끝내는 키다 — 보내지 않는다 (기존 sendUserQuestion 과 같은 검사)
      if (event && event.isComposing) return
      const question = this.text.trim()
      if (!question || this.disabled) return
      this.$emit('send', question)
      this.text = ''
    },
  },
}
</script>
